import React from "react"
import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok"
import Background from "../parts/background/background.js"

const LogoGrid = ({ blok }) => (
  <section
    className="block_logo_grid content_block"
    {...storyblokEditable(blok)}
    key={blok._uid}
  >
    <Background blok={blok.background_settings} />
    <div className="inner">
      {blok.Logos && (
        <div className="block-content">
          {blok.Logos.map(blok => (
            <div className="logo" key={blok._uid}>
              <StoryblokComponent blok={blok} />
            </div>
          ))}
        </div>
      )}
    </div>
  </section>
)

export default LogoGrid
